<div class="card payout-card mt-3">

    <div class="card-body">

        <h5 class="card-title">
            <i class="fa fa-university mr-2"></i>
            Payout Account
        </h5>

        <p class="text-muted mb-4">
            {{ stripeStatus.message }}
        </p>

      <button
    class="btn btn-primary"
    (click)="connectBankAccount()"
    [disabled]="stripeStatus.status === 'ACTIVE'">
    {{ getButtonText() }}
</button>

    </div>

</div>